<template>
  <EasyForm
    name="employee-whitelist"
    :model="formValues"
  >
    <fi-mselect
      name="employeeWhitelist"
      label="员工"
      :callback="getEmployeeList"
      placeholder="请选择员工"
    />
  </EasyForm>
</template>

<script lang="ts" setup>
import { EmployeeApi } from "api/LoginAPI";
import { PopupCtx, usePopup } from "@/components/easy";

const props = defineProps<{
  employeeWhitelist: number[];
  popupCtx?: PopupCtx<number[]>; // popup支持
}>();

const formValues = reactive({
  employeeWhitelist: props.employeeWhitelist,
});

async function getEmployeeList() {
  const response = await EmployeeApi.getEmployeeList();

  return response.data?.map((e) => ({
    id: e.employeeId,
    label: e.nickname,
  }));
}

const popup = usePopup(props);
popup.resultDef(() => {
  popup.done(formValues.employeeWhitelist);
});
</script>

<style lang="scss" scoped>
.blue-tip-logo {
  width: 4px;
  height: 12px;
  background: #3d8eff;
  border-radius: 1px;
}
</style>
